import React, { useEffect, useState } from 'react';
import { CompanyIdentity, getCompanySuggestions } from '../api/companies';
import { useLanguage } from '../context/LanguageContext';
import { experienceCopy } from '../locales/experience';
import CompanyPicker from './CompanyPicker';

const copy = {
  ru: {
    companySearch: 'Наименование компании или БИН / ИИН',
    companyPlaceholder: 'Наименование компании или БИН...',
    companyHint: 'Выберите компанию из подсказок или нажмите «Найти», чтобы искать по введённому тексту.',
    companySearchError: 'Подсказки временно недоступны. Можно повторить или нажать «Найти» для обычного поиска.',
    companyEmpty: 'Подсказок нет. Нажмите «Найти», чтобы выполнить поиск по введённому тексту.',
    bin: 'БИН / ИИН',
  },
  kk: {
    companySearch: 'Компания атауы немесе БСН / ЖСН',
    companyPlaceholder: 'Компания атауы немесе БСН...',
    companyHint: 'Ұсыныстардан компанияны таңдаңыз немесе енгізілген мәтін бойынша іздеу үшін «Іздеу» түймесін басыңыз.',
    companySearchError: 'Ұсыныстар уақытша қолжетімсіз. Қайталаңыз немесе кәдімгі іздеу үшін «Іздеу» түймесін басыңыз.',
    companyEmpty: 'Ұсыныстар жоқ. Енгізілген мәтін бойынша іздеу үшін «Іздеу» түймесін басыңыз.',
    bin: 'БСН / ЖСН',
  },
};

export default function SupplierCompanySearch({ value, onChange, id = 'supplier-company' }: {
  value: string;
  onChange: (value: string) => void;
  id?: string;
}) {
  const { language } = useLanguage();
  const [selected, setSelected] = useState<CompanyIdentity | null>(null);
  // Back/Forward and reset restore the URL query, without retaining a stale
  // selected name that would conceal the actual text or BIN being searched.
  useEffect(() => { setSelected(previous => previous?.bin === value ? previous : null); }, [value]);
  return <CompanyPicker id={id} value={selected?.bin === value ? selected : null}
    inputValue={value} onInputChange={onChange} allowFreeText allowManualBin={false}
    copy={{ ...experienceCopy[language], ...copy[language] }} loadCompanies={getCompanySuggestions}
    onChange={company => {
      setSelected(company);
      if (company) onChange(company.bin);
    }} />;
}
